import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { hideSpinner, showSpinner } from "../../../store/actions/loading";
import { Paginator } from '../../layout/Paginator/Paginator';
import { Search } from '../../layout/Table/Search';
import { TableComponent } from "./table/Table";
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { getEmailCampaigns as getEmailCampaignsApi } from "../../../api/emailCampaigns/emailCampaigns";
import { ListToolbar } from '../../layout/Workspace';

let oneTimeCall = false;
function EmailCampaignTableComponent(props) {
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ emailCampaigns, setEmailCampaigns ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );

  useEffect( () => {
    getEmailCampaigns( 1 );

    return () => {
      store.dispatch(hideNotification());
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    getEmailCampaigns(1, sortField, sortDirection, searchText);

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  /**
   * Get campaigns
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getEmailCampaigns = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;

    getEmailCampaignsApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
      },
      hideNotification: hideNotification
    } ).then(
      response => {
        if (! response || ! response.data) {
          return;
        }

        setEmailCampaigns( response.data );
        setMeta( response.meta );
        props.hideSpinner();
      }
    ).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getEmailCampaigns(meta.current_page, appliedSortField, newSortDirection, searchText, true);

  }

  return (
    <div className="email-campaigns-list-layout">
      <ListToolbar
        className="email-campaigns-list-toolbar"
        search={(
          <Search
            id="emailCampaign"
            search={searchText => {
              setSearchText( searchText );
              getEmailCampaigns( 1, null, null, searchText, true);
            }}
          />
        )}
        settings={(
          <AutoRefreshTable
            id="emailCampaigns"
            getData={ getEmailCampaigns }
            sortDirection={ sortDirection }
            sortField={ sortField }
            searchText={ searchText }
          />
        )}
      />
      <div className="email-campaigns-list-table">
        <TableComponent
          shouldRenderFields={ true }
          applySort={ sortField => applySort( sortField ) }
          emailCampaigns={ emailCampaigns }
          actionCallback={
            useState => {
              if (useState) {
                getEmailCampaigns(meta.current_page, sortField, sortDirection, searchText);
              } else {
                getEmailCampaigns();
              }
            }
          }
        />
      </div>
      <div className="email-campaigns-list-pagination">
        <Paginator
          meta={ meta }
          settings={(
            <RowsPerPage
              id="emailCampaign"
              changeRowsPerPage={rowsPerPage => {
                setRowsPerPage(rowsPerPage);
              }}
            />
          )}
          changePage={ page => getEmailCampaigns(page, sortField, sortDirection, searchText, true) }
        />
      </div>
    </div>
  )
}

const EmailCampaignTable = connect(null, { showSpinner, hideSpinner })(EmailCampaignTableComponent);

export { EmailCampaignTable, EmailCampaignTableComponent };
